import { useState } from "react";
import { IoMdAddCircleOutline } from "react-icons/io";
import { AiOutlineInsertRowRight } from "react-icons/ai";
import { BiCross } from "react-icons/bi";
import { FaPaperPlane } from "react-icons/fa";
// import MultipleImgInputTag from "./MultipleImgInputTag";
import IndexInsertionForm from "./IndexInsertionForm";

function CustomMultiInputForm({
  update,
  oldData,
  fullHeight = true,
  pageTitle,
  name,
  subTitle,
  setMultiFormDataX,
  disableApiSubmit,
}) {
  const [toggle, setToggle] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [formFields, setFormFields] = useState(
    oldData
      ? oldData
      : [
          {
            counterNumber: "",
            counterNumberBn: "",
            nameEn: "",
            nameBn: "",
            tags: "",
          },
        ]
  );

  const handleFormChange = (event, index) => {
    let data = [...formFields];
    data[index][event.target.name] = event.target.value;
    // ?.toLowerCase()
    setFormFields(data);
    // setMultiFormDataX(data);
  };

  const submit = (e) => {
    e.preventDefault();
    setClicked(true);
    // reform
    const updatedFormFields = formFields.map((item, idx) => {
      let obj = { ...item };
      obj.serialNo = (idx + 1).toString();
      if (obj._id) {
        delete obj._id;
      }
      return obj;
    });

    // send data
    if (disableApiSubmit) {
      // save to parent state
      setMultiFormDataX(updatedFormFields);
    } else {
      // Update api
      update(updatedFormFields);
    }
  };

  const addFields = () => {
    let object = {
      counterNumber: "",
      counterNumberBn: "",
      nameEn: "",
      nameBn: "",
      tags: "",
    };
    setFormFields([...formFields, object]);
  };

  const removeFields = (index) => {
    let data = [...formFields];
    data.splice(index, 1);
    setFormFields(data);
  };

  return (
    <div className="mb-12">
      <h2
        className={`col-span-4 font-semibold text-2xl text-gray-600 dark:text-darkWhite text-center w-full mt-12`}
      >
        {pageTitle}
      </h2>
      <p className="w-full border-b border-dashed dark:border-darkBorder pb-4  text-center text-gray-400 tracking-wide mt-1 mb-16 lxs:mb-12 text-sm lg:text-base">
        {subTitle}
      </p>
      {/* Form */}
      <form onSubmit={submit}>
        {formFields.map((form, index) => {
          return (
            <div
              key={index}
              className="flex flex-col items-start relative mb-2"
            >
              <span className="text-gray-600 dark:text-darkWhite font-medium">
                Route {index + 1}
              </span>

              {/* -----------{visible input for value taking}----------- */}
              <input
                name="nameEn"
                type="text"
                placeholder="Enter route name"
                onChange={(event) => handleFormChange(event, index)}
                value={form.nameEn}
                className="w-[90%] my-2 darkPrimary border border-gray-300 rounded-md px-3 py-2.5 z-0 bg-transparent outline-none dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500 focus:border-secondary dark:focus:border-secondary transition-colors duration-150"
                required
              />
              <input
                name="nameBn"
                type="text"
                placeholder="Enter route name - bangla"
                onChange={(event) => handleFormChange(event, index)}
                value={form.nameBn}
                className="w-[90%] my-2 darkPrimary border border-gray-300 rounded-md px-3 py-2.5 z-0 bg-transparent outline-none dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500 focus:border-secondary dark:focus:border-secondary transition-colors duration-150"
                required
              />
              <input
                name="tags"
                type="text"
                placeholder="Enter tags (separate by comma)"
                onChange={(event) => handleFormChange(event, index)}
                value={form.tags}
                className="w-[90%] my-2 darkPrimary border border-gray-300 rounded-md px-3 py-2.5 z-0 bg-transparent outline-none dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500 focus:border-secondary dark:focus:border-secondary transition-colors duration-150"
                required
              />
              <input
                name="counterNumber"
                type="text"
                placeholder="Enter contact number"
                onChange={(event) => handleFormChange(event, index)}
                value={form.counterNumber}
                className="w-[90%] my-2 darkPrimary border border-gray-300 rounded-md px-3 py-2.5 z-0 bg-transparent outline-none dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500 focus:border-secondary dark:focus:border-secondary transition-colors duration-150"
              />
              <input
                name="counterNumberBn"
                type="text"
                placeholder="Enter contact number - bangla"
                onChange={(event) => handleFormChange(event, index)}
                value={form.counterNumberBn}
                className="w-[90%] my-2 darkPrimary border border-gray-300 rounded-md px-3 py-2.5 z-0 bg-transparent outline-none dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500 focus:border-secondary dark:focus:border-secondary transition-colors duration-150"
              />
              {/* Remove button */}
              <div className="absolute -right-3 top-5 lxs:top-0 sm:right-5 sm:top-5 h-[calc(100%+10px)] flex items-center justify-center">
                <span
                  title="Remove"
                  onClick={() => removeFields(index)}
                  className="block rotate-45 border rounded-full p-1 border-gray-300 cursor-pointer text-gray-400 hover:text-red-500 hover:border-red-500 dark:hover:text-red-500 dark:text-darkerWhite dark:border-darkerWhite dark:hover:border-red-500 transition-colors duration-150"
                >
                  <BiCross className="text-2xl" />
                </span>
              </div>
            </div>
          );
        })}

        {/* Add more button */}
        <button
          title="Add more"
          type="button"
          onClick={addFields}
          className="px-2.5 py-2 border dark:border-darkBorder dark:hover:bg-darkPrimary rounded-md cursor-pointer bg-secondary/70 hover:bg-secondary text-primary border-secondary/10 hover:border-secondary transition duration-150 flex items-center gap-1 mt-3"
        >
          <span>Add More</span>
          <IoMdAddCircleOutline />
        </button>

        {/* SUBMIT button */}
        <div className="w-full mt-12 mb-10 flex items-center justify-center">
          <button
            type="submit"
            // onClick={submit}
            className={`${
              clicked
                ? "bg-secondary hover:bg-secondary/70"
                : "bg-red-500 hover:bg-red-500/70"
            } btn btnW7ide font-bold text-white hover:shadow-lg px-8 sm:px-12 py-3 sm:py-3.5 rounded-lg transition duration-150 tracking-wider dark:border-darkBorder dark:hover:bg-darkPrimary focus:ring-2 ring-black`}
          >
            <span>Submit</span>
            <FaPaperPlane className="inline ml-2.5 mb-0.5 text-sm" />
          </button>
        </div>
      </form>

      {/* ------------{specific index insertion}------------ */}
      {/* toggle open/close */}
      <button
        onClick={() => setToggle((old) => !old)}
        title="toggle position insertion"
        type="button"
        className="mr-auto mt-[48px] px-2.5 py-2 border dark:border-darkBorder dark:hover:bg-darkPrimary rounded-md cursor-pointer bg-secondary/70 hover:bg-secondary text-primary border-secondary/10 hover:border-secondary transition duration-150 flex items-center gap-1"
      >
        <span>Toggle Indexing</span>
        <AiOutlineInsertRowRight />
      </button>

      {/* main component */}
      <div
        className={`${
          toggle ? "max-h-[50rem]" : "max-h-0"
        } transition-all duration-300 overflow-hidden`}
      >
        <IndexInsertionForm
          formFields={formFields}
          setFormFields={setFormFields}
        />
      </div>
    </div>
  );
}

export default CustomMultiInputForm;
